import { render, staticRenderFns } from "./SubFolderDocumentConfiguration.vue?vue&type=template&id=1ac738ae&scoped=true&"
import script from "./SubFolderDocumentConfiguration.vue?vue&type=script&lang=js&"
export * from "./SubFolderDocumentConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SubFolderDocumentConfiguration.vue?vue&type=style&index=0&id=1ac738ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac738ae",
  null
  
)

export default component.exports